import React, { useState } from "react";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import "./TravelTips.css";
import { useTranslation, Trans } from "react-i18next";

const TravelTips = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const { t } = useTranslation("destinations");

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = t("faq", { returnObjects: true });

  return (
    <div className="faq-container">
      <h2 className="faq-title">{t("faqTitle")}</h2>
      <div className="faq-list">
        {faqs.map((item, index) => (
          <div
            key={index}
            className={`faq-item ${openIndex === index ? "open" : ""}`}
            onClick={() => toggle(index)}
          >
            <div className="faq-question">
              <AiOutlineQuestionCircle className="faq-icon" />
              {item.question}
            </div>
            {openIndex === index && (
              <div className="faq-answer">
                <Trans i18nKey={`faq.${index}.answer`} ns="destinations" />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TravelTips;
